import styled, { css } from "styled-components";
import { Image } from "cloudinary-react";

const disablePrinting = css`
  @media print {
    display: none;
  }
`;

export const Heading = styled.div`
  font-size: 1.5em;
  margin-bottom: 10px;
  padding: 10px 0;

  @media screen and (min-width: 768px) {
    font-size: 2em;
    margin-bottom: 20px;
    padding: 20px 0;
  }
`;

export const ThankYou = styled.p`
  font-size: 1.125em;
  font-weight: 500;
  margin-bottom: 20px;
`;

export const LoadingEntryNumbers = styled.p`
  margin-bottom: 20px;
`;

export const EntrySummary = styled.div`
  font-size: 1.25em;
  font-weight: 500;
  margin-bottom: 10px;
  color: #333333;
`;

export const EntryNumbers = styled.div`
  font-size: 1.75em;
  font-weight: 500;
  margin-bottom: 20px;
  color: #333333;
`;

export const Message = styled.p`
  color: #555555;
  margin-bottom: 20px;
  line-height: 1.25em;
`;

export const ShareCTA = styled.p`
  color: #555555;
  margin-bottom: 20px;
  ${disablePrinting}
`;

export const LargeThankYouCampaignImage = styled.img`
  width: 100%;
  margin-bottom: 10px;

  @media screen and (max-width: 480px) {
    display: none;
  }
  ${disablePrinting}
`;

export const SmallThankYouCampaignImage = styled.img`
  width: 100%;
  margin-bottom: 10px;

  @media screen and (min-width: 481px) {
    display: none;
  }
  ${disablePrinting}
`;

export const LargeSponsorCampaignImage = styled(LargeThankYouCampaignImage).attrs({
  as: Image,
})`
  ${disablePrinting}
`;

export const SmallSponsorCampaignImage = styled(SmallThankYouCampaignImage).attrs({
  as: Image,
})`
  ${disablePrinting}
`;

export const HiddenAmount = styled.div`
  display: none;
`;
